import { AnyAction } from '@reduxjs/toolkit'
import { keyBy, reject } from 'lodash'

import { CREATE_ATTRIBUTE_SUCCESS } from '@/pages/OrganizationUserAttributeCreatePage/actionTypes'
import { EDIT_ATTRIBUTE_SUCCESS } from '@/pages/OrganizationUserAttributeEditPage/actionTypes'

import { DELETE_ATTRIBUTE_SUCCESS, FETCH_ATTRIBUTE_SUCCESS, FETCH_ATTRIBUTES_SUCCESS } from './actionTypes'

export type OrganizationUserAttributesPageState = {
  byId: Record<string, any>
}

export const initialState: OrganizationUserAttributesPageState = { byId: {} }

export default (state = initialState, action: AnyAction): OrganizationUserAttributesPageState => {
  switch (action.type) {
    case CREATE_ATTRIBUTE_SUCCESS:
    case EDIT_ATTRIBUTE_SUCCESS:
    case FETCH_ATTRIBUTE_SUCCESS: {
      return { ...state, byId: { ...state.byId, [action.response.id]: action.response } }
    }

    case DELETE_ATTRIBUTE_SUCCESS: {
      return { ...state, byId: keyBy(reject(state.byId, { id: action.attributeId }), 'id') }
    }

    case FETCH_ATTRIBUTES_SUCCESS: {
      return { ...state, byId: { ...state.byId, ...keyBy(action.response, 'id') } }
    }

    default: {
      return state
    }
  }
}
